module.exports = __webpack_public_path__ + "_assets/img/ptTaoyuan.e9f9e7a2.svg";